export const EVENT_CATEGORY = "Banner";
export const MODULE = "hero_carousel";

export const EVENTS = {
  BANNER_CAROUSEL_CLICKED: "Banner Link Clicked",
  BANNER_CAROUSEL_VIEWED: "Banner Viewed",
  EDUCATION_ARTICLE_SELECTED: "Education Article Selected",
  HOMEPAGE_LAYOUT_APPLIED: "Home Page Layout Applied"
};
